import React, { useRef } from "react";

import { useOnClickOutside } from "@/hooks/use-on-click-outside";
import { useOnKeyPress } from "@/hooks/use-on-key-press";

import { BlackBackground } from "./partials/black-background";
import { InfoBar } from "./partials/info-bar";
import { Overlay } from "./partials/overlay";

type PlayerOverlayProps = React.PropsWithChildren<{
  title?: string;
  onClose: () => void;
}>;

export const PlayerOverlay = (
  props: React.PropsWithChildren<PlayerOverlayProps>
) => {
  const { onClose, title, children } = props;
  const ref = useRef();

  useOnClickOutside(ref, onClose);
  useOnKeyPress("Escape", onClose);

  return (
    <Overlay ref={ref}>
      <InfoBar title={title} onClose={onClose} />
      <BlackBackground>{children}</BlackBackground>
    </Overlay>
  );
};

//
